// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import {
  PlasmicLauncherBlocksFeaturedApps,
  DefaultLauncherBlocksFeaturedAppsProps
} from "./plasmic/launcher/PlasmicLauncherBlocksFeaturedApps";
import { HTMLElementRefOf } from "@plasmicapp/react-web";

export interface LauncherBlocksFeaturedAppsProps
  extends DefaultLauncherBlocksFeaturedAppsProps {}

function LauncherBlocksFeaturedApps_(
  props: LauncherBlocksFeaturedAppsProps,
  ref: HTMLElementRefOf<"div">
) {
  // Do not remount when doctor/Growthbook identity resolves — that caused FOUC
  // (sections painting before CSS modules re-applied).
  return (
    <PlasmicLauncherBlocksFeaturedApps
      root={{ ref }}
      {...props}
      apiRequest3={{ params: {} }}
      apiRequest2={{ params: {} }}
    />
  );
}

const LauncherBlocksFeaturedApps = React.forwardRef(
  LauncherBlocksFeaturedApps_
);
export default LauncherBlocksFeaturedApps;
